const sanitizeName = (value = "") =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9\s]/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 3)
    .join("-");

export const buildReadableCode = (prefix, name) => {
  const safePrefix = (prefix || "ID").toUpperCase();
  const readable = sanitizeName(name) || "ITEM";
  const date = new Date();
  const stamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}${String(
    date.getDate(),
  ).padStart(2, "0")}`;
  const random = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `${safePrefix}-${readable}-${stamp}-${random}`.slice(0, 50);
};
